import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import * as pathUtils from "../../../abstract/controller/utils/pathUtils";
import Labels from "../../label/Labels";
import styles from "./ReadOnlyChoiceHeader.module.scss";

function ReadOnlyChoiceHeader({ id, element: node, children }) {
  const _name = pathUtils.getName(id);
  const _isAbstract = nodeUtils.isAbstract(node);
  const _labels = nodeUtils.getLabel(node);

  //---------------------------------------------------------------------

  const getClass = () => {
    return `${styles["header__form"]} ${
      styles[`header__form--${_isAbstract ? "abstract" : "concrete"}`]
    } `;
  };

  const getClassInput = () => {
    return `${styles["header__name-input"]} ${
      _isAbstract ? styles["header-abstract__name-input"] : styles["header-concrete__name-input"]
    }`;
  };

  const getClassAbstract = () => {
    return `${styles["header"]} ${
      _isAbstract ? styles["header-abstract"] : styles["header-concrete"]
    }`;
  };

  return (
    <div className={getClassAbstract()}>
      <form  className={getClass()}>
        <input className={getClassInput()} value={_name} disabled={true} />
        <HeaderShowValue node={node} isAbstract={_isAbstract} />
        {_labels.length > 0 && <Labels node={node} readOnly/> }
      </form>
      <div>{children}</div>
    </div>
  );
}

function HeaderShowValue({ node, isAbstract }) {
  const uuid = nodeUtils.getUUID(node);
  const value = nodeUtils.getValue(node);

  if (isAbstract || !value) {
    return null;
  }

  return (
    <div id={`input-value-${uuid}`} className={styles["header__value"]}>
      {value}
    </div>
  );
}

export default ReadOnlyChoiceHeader;
